// apps/share-web/src/song-screen/mode-switch.ts
//
// Режимы экрана песни: Mix | Chart & Lyrics (ДС bw-segmented-control). Последний
// режим помнит store (bw.song.mode). Справа — ⋯ микшера (виден только в Mix).
// Песня без слов — сегмента нет: Mix единственный режим.
import '@bandway/ui-components';
import '@bandway/ui-components/styles/bw-segmented-control.css';
import { iconButton } from '../chart/chart-buttons.js';
import type { SongScreenStore, SongMode } from './song-screen-store.js';
import { t } from '../ui/i18n.js';
import '../styles/song-screen.css';

export interface ModeSwitchDeps { store: SongScreenStore; hasChart: boolean; onMixMenu: () => void; }
export interface ModeSwitchHandle { destroy(): void; }

type SegEl = HTMLElement & { segments: Array<{ value: string; label: string }>; value: string; size: string };

export function mountModeSwitch(host: Element, d: ModeSwitchDeps): ModeSwitchHandle {
  const root = document.createElement('div');
  root.className = 'ss-modes-row';
  const mode = (): SongMode => (d.hasChart ? d.store.get().mode : 'mix');
  let seg: SegEl | null = null;
  const onChange = (e: Event): void => {
    const v = (e as CustomEvent<{ value: string }>).detail.value;
    d.store.set({ mode: v === 'chart' ? 'chart' : 'mix' });
  };
  if (d.hasChart) {
    seg = document.createElement('bw-segmented-control') as SegEl;
    seg.size = 'md';
    seg.segments = [{ value: 'mix', label: t('songScreen.modeMix') }, { value: 'chart', label: t('chart.open') }];
    seg.value = mode();
    seg.setAttribute('aria-label', t('songScreen.modesLabel'));
    seg.addEventListener('bw-segmented-change', onChange);
    root.appendChild(seg);
  }
  const more = iconButton({ glyph: '⋯', name: t('songScreen.mixMenu'), size: 'lg', cls: 'ss-mix-more', onClick: d.onMixMenu });
  root.appendChild(more);
  const sync = (): void => {
    if (seg) seg.value = mode();
    more.hidden = mode() !== 'mix';
  };
  const unsub = d.store.subscribe((s, prev) => { if (s.mode !== prev.mode) sync(); });
  sync();
  host.appendChild(root);
  return {
    destroy() { unsub(); seg?.removeEventListener('bw-segmented-change', onChange); root.remove(); },
  };
}
